import { render } from "./GanttChart.vue?vue&type=template&id=f3dfb154&scoped=true"
import script from "./GanttChart.vue?vue&type=script&lang=js"
export * from "./GanttChart.vue?vue&type=script&lang=js"

import "./GanttChart.vue?vue&type=style&index=0&id=f3dfb154&scoped=true&lang=css"
import "./GanttChart.vue?vue&type=style&index=1&id=f3dfb154&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3dfb154"]])

export default __exports__